/* ============================================
   CHAT ASSISTANT - MODULAR FAKE BOT
   ============================================ */

class ChatAssistant {
  constructor() {
    this.container = document.querySelector('[data-chat-assistant]');
    if (!this.container) return;

    this.config = window.chatAssistantConfig || {};
    this.categories = this.config.categories || [];
    
    this.teaser = this.container.querySelector('[data-chat-teaser]');
    this.toggle = this.container.querySelector('[data-chat-toggle]');
    this.window = this.container.querySelector('[data-chat-window]');
    this.messagesContainer = this.container.querySelector('[data-chat-messages]');
    this.closeBtn = this.container.querySelector('[data-chat-close]');
    this.teaserClose = this.container.querySelector('[data-teaser-close]');
    this.input = this.container.querySelector('[data-chat-input]');
    this.sendBtn = this.container.querySelector('[data-chat-send]');

    this.isOpen = false;
    this.hasStarted = false;
    this.currentCategory = null;

    this.init();
  }

init() {
  // Event listeners
  this.toggle.addEventListener('click', () => this.openChat());
  this.closeBtn.addEventListener('click', () => this.closeChat());
  this.teaserClose?.addEventListener('click', (e) => {
    e.stopPropagation();
    this.teaser.classList.remove('is-visible');
    clearTimeout(this.teaserAutoHide);
  });
  this.teaser?.addEventListener('click', () => this.openChat());

  this.input.addEventListener('keypress', (e) => {
    if (e.key === 'Enter' && this.input.value.trim()) {
      this.handleCustomInput(this.input.value.trim());
      this.input.value = '';
    }
  });
  this.sendBtn.addEventListener('click', () => {
    if (this.input.value.trim()) {
      this.handleCustomInput(this.input.value.trim());
      this.input.value = '';
    }
  });

  // Show teaser after delay
  setTimeout(() => {
    if (!this.isOpen) {
      this.teaser?.classList.add('is-visible');
      
      // Auto-hide after 3 seconds
      this.teaserAutoHide = setTimeout(() => {
        this.teaser?.classList.remove('is-visible');
      }, 3000);
    }
  }, this.config.teaserDelay || 3000);
}

openChat() {
  this.isOpen = true;
  this.window.classList.add('is-open');
  this.container.classList.add('is-chat-open');
  this.teaser?.classList.remove('is-visible');
  clearTimeout(this.teaserAutoHide);

  if (!this.hasStarted) {
    this.hasStarted = true;
    this.startConversation();
  }
}

  closeChat() {
    this.isOpen = false;
    this.window.classList.remove('is-open');
    this.container.classList.remove('is-chat-open');
  }

startConversation() {
  const openingMessages = this.config.openingMessages || [];
  
  if (openingMessages.length > 0) {
    this.sendBotMessages(openingMessages, () => {
      const yesOption = this.config.initialYes || 'yes';
      const noOption = this.config.initialNo || 'maybe';
      this.showResponses([yesOption, noOption], (response) => {
        this.handleInterestResponse(response);
      });
    });
  }
}

handleInterestResponse(response) {
  this.addMessage(response, 'user');
  
  const yesOption = (this.config.initialYes || 'yes').toLowerCase();
  const noOption = (this.config.initialNo || 'maybe').toLowerCase();
  
  // Treat both options as interested (they clicked something)
  const positiveResponses = ['yes', 'yeah', 'yep', 'yessir', 'sure', 'ok', 'okay', 'maybe', yesOption, noOption];
  const isInterested = positiveResponses.some(y => response.toLowerCase().includes(y));
  
  if (isInterested) {
    this.askCategoryQuestion();
  } else {
    this.sendBotMessages([this.config.declineMessage || "no worries, hit me up whenever you're ready 🤙"]);
  }
}

  askCategoryQuestion() {
    setTimeout(() => {
      this.showTyping();
      
      setTimeout(() => {
        this.hideTyping();
        this.addMessage(this.config.categoryQuestion || "cool. what kind of stuff are you thinking of selling?", 'bot');
        
        const categoryNames = this.categories.map(c => c.nameDisplay).filter(c => c);
        
        if (categoryNames.length > 0) {
          setTimeout(() => {
            this.showResponses(categoryNames, (response) => {
              this.handleCategoryResponse(response);
            });
          }, 300);
        }
      }, this.config.typingDuration || 1500);
    }, this.config.messageDelay || 2000);
  }

  handleCategoryResponse(response) {
    this.addMessage(response, 'user');
    
    const category = this.categories.find(c => 
      c.nameDisplay?.toLowerCase() === response.toLowerCase() ||
      c.name?.toLowerCase() === response.toLowerCase()
    );
    
    if (category && category.products.length > 0) {
      this.currentCategory = category;
      this.showProductRecommendations(category);
    } else {
      this.sendBotMessages(["hmm I don't have a specific vendor for that yet, but check out what we got on the site!"]);
    }
  }

  showProductRecommendations(category) {
    setTimeout(() => {
      this.showTyping();
      
      setTimeout(() => {
        this.hideTyping();
        
        // Show recommendation message
        this.addMessage(category.message || "Nice choice! Here are some options:", 'bot');
        
        // Show product cards
        setTimeout(() => {
          this.showProductCards(category.products);
          
          // Show confirm/decline after products
          setTimeout(() => {
            const confirmBtn = this.config.confirmYes || 'bet';
            const declineBtn = this.config.confirmNo || 'nah maybe later';
            
            this.showResponses([confirmBtn, declineBtn], (response) => {
              this.handleConfirmation(response);
            });
          }, 500);
        }, 300);
        
      }, this.config.typingDuration || 1500);
    }, this.config.messageDelay || 2000);
  }

  showProductCards(products) {
    const wrapper = document.createElement('div');
    wrapper.className = 'chat-assistant__products';
    
    products.forEach(product => {
      const card = document.createElement('a');
      card.href = product.url;
      card.className = 'chat-assistant__product-card';
      
      let priceHtml = `<span class="chat-assistant__product-price">${product.price}</span>`;
      if (product.hasComparePrice) {
        priceHtml += `<span class="chat-assistant__product-compare">${product.comparePrice}</span>`;
      }
      
      card.innerHTML = `
        ${product.image ? `<img src="${product.image}" alt="${product.title}" class="chat-assistant__product-image">` : ''}
        <div class="chat-assistant__product-info">
          <span class="chat-assistant__product-title">${product.title}</span>
          <div class="chat-assistant__product-prices">${priceHtml}</div>
        </div>
      `;
      
      wrapper.appendChild(card);
    });
    
    this.messagesContainer.appendChild(wrapper);
    this.scrollToBottom();
  }

  handleConfirmation(response) {
    this.addMessage(response, 'user');
    
    const confirmText = (this.config.confirmYes || 'bet').toLowerCase();
    const isConfirmed = response.toLowerCase() === confirmText || 
                        response.toLowerCase().includes('bet') ||
                        response.toLowerCase().includes('yes') ||
                        response.toLowerCase().includes('yeah');
    
    if (isConfirmed) {
      this.showFinalCTA();
    } else {
      this.sendBotMessages([this.config.declineMessage || "no worries, hit me up whenever you're ready 🤙"]);
    }
  }

  showFinalCTA() {
    setTimeout(() => {
      this.showTyping();
      
      setTimeout(() => {
        this.hideTyping();
        this.addMessage(this.config.followUpMessage || "Awesome. If you're ready to grab that, just hit checkout when you're ready.", 'bot');
        
        // Show CTA buttons for all products in category
        if (this.currentCategory && this.currentCategory.products.length > 0) {
          const ctaWrapper = document.createElement('div');
          ctaWrapper.className = 'chat-assistant__cta-wrapper';
          
          if (this.currentCategory.products.length === 1) {
            // Single product - one button
            const product = this.currentCategory.products[0];
            ctaWrapper.innerHTML = `
              <a href="${product.url}" class="chat-assistant__cta">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
                  <circle cx="9" cy="21" r="1"/>
                  <circle cx="20" cy="21" r="1"/>
                  <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
                </svg>
                ${this.config.ctaText || 'Checkout Now'}
              </a>
            `;
          } else {
            // Multiple products - button for each
            this.currentCategory.products.forEach(product => {
              ctaWrapper.innerHTML += `
                <a href="${product.url}" class="chat-assistant__cta chat-assistant__cta--small">
                  ${product.title} - ${product.price}
                </a>
              `;
            });
          }
          
          this.messagesContainer.appendChild(ctaWrapper);
          this.scrollToBottom();
        }
      }, this.config.typingDuration || 1500);
    }, this.config.messageDelay || 2000);
  }

  handleCustomInput(text) {
    this.addMessage(text, 'user');
    
    const category = this.categories.find(c => 
      text.toLowerCase().includes(c.name?.toLowerCase()) ||
      text.toLowerCase().includes(c.nameDisplay?.toLowerCase())
    );
    
    if (category && category.products.length > 0) {
      this.currentCategory = category;
      this.showProductRecommendations(category);
    } else {
      setTimeout(() => {
        this.showTyping();
        setTimeout(() => {
          this.hideTyping();
          this.addMessage("yo check out our products on the site, we got something for everyone 💪", 'bot');
        }, this.config.typingDuration || 1500);
      }, 500);
    }
  }

  sendBotMessages(messages, callback) {
    let index = 0;
    
    const sendNext = () => {
      if (index >= messages.length) {
        if (callback) callback();
        return;
      }

      this.showTyping();

      setTimeout(() => {
        this.hideTyping();
        this.addMessage(messages[index], 'bot');
        index++;
        
        setTimeout(sendNext, this.config.messageDelay || 2000);
      }, this.config.typingDuration || 1500);
    };

    sendNext();
  }

  showResponses(responses, callback) {
    const wrapper = document.createElement('div');
    wrapper.className = 'chat-assistant__responses';

    responses.forEach(response => {
      const btn = document.createElement('button');
      btn.className = 'chat-assistant__response-btn';
      btn.textContent = response;
      btn.addEventListener('click', () => {
        wrapper.remove();
        if (callback) callback(response);
      }, { once: true });
      wrapper.appendChild(btn);
    });

    this.messagesContainer.appendChild(wrapper);
    this.scrollToBottom();
  }

  addMessage(text, type) {
    const msg = document.createElement('div');
    msg.className = `chat-assistant__message chat-assistant__message--${type}`;
    msg.textContent = text;
    this.messagesContainer.appendChild(msg);
    this.scrollToBottom();
  }

  showTyping() {
    const existing = this.messagesContainer.querySelector('[data-typing]');
    if (existing) return;
    
    const typing = document.createElement('div');
    typing.className = 'chat-assistant__typing';
    typing.setAttribute('data-typing', '');
    typing.innerHTML = `
      <span class="chat-assistant__typing-dot"></span>
      <span class="chat-assistant__typing-dot"></span>
      <span class="chat-assistant__typing-dot"></span>
    `;
    this.messagesContainer.appendChild(typing);
    this.scrollToBottom();
  }

  hideTyping() {
    const typing = this.messagesContainer.querySelector('[data-typing]');
    if (typing) typing.remove();
  }

  scrollToBottom() {
    this.messagesContainer.scrollTop = this.messagesContainer.scrollHeight;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ChatAssistant();
});